import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buttons has-addons" }

import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebAssistantViewToggle',
  props: {
  activeView: {
    type: String as PropType<'homescreen' | 'conversation'>,
    required: true,
  },
},
  emits: ["viewChange"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

function setActiveView(view: 'homescreen' | 'conversation') {
  emit('viewChange', view);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["button", { 'is-static': __props.activeView === 'homescreen' }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveView('homescreen')))
    }, "Homescreen", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["button", { 'is-static': __props.activeView === 'conversation' }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveView('conversation')))
    }, "Conversation", 2)
  ]))
}
}

})